"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledCollapseAll = exports.StyledBodyItem = exports.StyledBody = exports.StyledHeader = void 0;
const ui_components_1 = require("@groupby/ui-components");
const styled_components_1 = __importDefault(require("styled-components"));
const { background050, background100, background600, white, } = ui_components_1.baseColors;
exports.StyledHeader = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 0.25rem 0.5rem;

  background-color: #004248;
  border: 1px solid ${background600};

  color: ${white};
  font-size: 0.75rem;
`;
exports.StyledBody = styled_components_1.default.ul `
  margin: 0;
  padding: 0.25rem 0;

  background-color: ${background050};
  border-top: 1px solid ${background100};
`;
exports.StyledBodyItem = styled_components_1.default.li `
  padding: 0.75rem 0.63rem;
  font-size: 0.75rem;
`;
exports.StyledCollapseAll = styled_components_1.default.div `
  text-transform: uppercase;

  color: ${ui_components_1.baseColors.primaryGreen100};
  font-size: 0.63rem;

  cursor: pointer;

  &:hover {
    color: ${ui_components_1.baseColors.primaryGreen000};
  }
`;
